<template>
<div class="d-flex justify-content-center mb-5 mt-5">

    <div class="col-xl-6 col-lg-8 col-md-10">
        <div class="card shadow h-100" v-if="post && post.id > 0">
            <div class="card-header bg-primary py-3 d-flex flex-row align-items-center justify-content-between text-white">

                <h6 class="m-0 font-weight-bold">
                    {{ post.title }}
                </h6>
            </div>

            <div class="card-body">
                <div class="row no-gutters text-xs">
                    <!-- 
                        Afficher SI ADMIN
                        <div class="col">
                        {{ $t("consult.status") }} : <span class="badge badge-primary">{{ $t("consult.post_status."+post.status) }}</span>
                    </div> -->
                    <div class="col text-left">
                        {{ $t("consult.post_date") }}
                        {{ moment(post.post_date).format('LLL') }} <br />

                        {{ $t("consult.created_by") }}
                        {{post.author_realname}} ({{post.author_email}})
                    </div>
                    <div class="col text-right">
                        Ref. {{post.id}}
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col">

                        <hr class="sidebar-divider">

                        <h3 class="h3 font-weight-bold">Description</h3>
                        <div>{{ post.content | multitranslate}}</div>

                        <div v-show="post.medias.length > 0">

                            <hr class="sidebar-divider">

                            <div class="row">

                                <div class="col" v-for="(image, index) in post.medias" :key="index">
                                    <img :src="baseUrl+'/storage/'+image.o_filename" alt="" class="img-fluid" />
                                </div>

                            </div>

                        </div>

                        <hr class="sidebar-divider">

                        <div class="mb-1 row">
                            <div class="col-md-12" v-for="attribute in post.attributes" :key="attribute.key">
                                <template v-if="!attribute.hidden && !attribute.response_private">
                                    <h3 class="h3 font-weight-bold">{{attribute.label | multitranslate}}</h3>
                                    <p>{{attribute.pivot.value}}</p>
                                </template>
                            </div>
                        </div>

                        <div v-if="JSON.stringify(point) !== JSON.stringify({})">
                            <hr class="sidebar-divider">
                            
                            <l-map ref="myMap" style="height: 500px; width: 100%; z-index:1;" :zoom="zoom" :center="center">
                                <l-tile-layer :url="url" :attribution="attribution" />
                                <l-marker ref="maPosition" :lat-lng="point" :icon="icon" />
                            </l-map>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
</template>

<style scoped>
.images {
    max-height: 250px;
    margin-bottom: 1em;
}
</style>

<script>
import {
    L,
    latLng,
    icon
} from "leaflet";
import {
    LMap,

    LTileLayer,
    LGeoJson,
    LMarker,
    LPopup,
    LIcon,
} from 'vue2-leaflet';
//Services
import {
    APIService
} from '@/service/APIService.js'

export default {
    name: 'Consult',
    components: {
        APIService,
        L,
        LMap,
        LTileLayer,
        LMarker,
        LGeoJson,
        LIcon,
    },
    data: function () {
        return {
            baseUrl: this.$store.state.vueAppBackendUrl,
            post: {},
            zoom: 15,
            center: {},
            url: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidXNoYWhpZGkiLCJhIjoiY2lxaXUzeHBvMDdndmZ0bmVmOWoyMzN6NiJ9.CX56ZmZJv0aUsxvH5huJBw',
            attribution: '&copy; <a href="javascript:void(0)">OpenStreetMap</a>, &copy; <a href="javascript:void(0)">Mapbox</a> | <a href="javascript:void(0)" target="_blank">Improve the underlying map</a>',
            point: {},
            icon: null
        }
    },
    created() {
        if (process.env.VUE_APP_STANDALONE === 'true') {
            this.imagePath = '/img/target.png';
        } else {
            this.imagePath = this.$store.state.vueAppBaseUrl + '/dist/img/target.png';
        }
        this.icon = icon({
            iconUrl: this.imagePath,
            iconSize: [37, 37],
            iconAnchor: [18, 18]
        })

        var that = this;
        var key = this.$route.query.key;

        APIService.setEndpoints(this.$store.state.vueAppBackendUrl, this.$store.state.vueAppModernApiUrl);

        APIService.getPublicPost(this.$store.state.consultUrl, key, function (response) {
            that.post = response;

            if(response.point && response.point.value && response.point.value.coordinates[1]){
                that.point = latLng(response.point.value.coordinates[1], response.point.value.coordinates[0])
                that.center = that.point;
            }

            that.hideLoader();
        });
    },

    methods: {
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        redraw: function () {
            this.$nextTick(() => {
                this.$refs.myMap.mapObject.invalidateSize();
            });
        },
        getLatLng: function (coords) {
            return latLng(coords[1], coords[0]);
        },
        hideLoader: function () {
            var loader = document.getElementById('wizard-loading');
            if (loader)
                document.getElementById('wizard-loading').style.display = "none";
        }
    },
    mounted() {}
}
</script>
